(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("autoloaderCdn", [], factory);
	else if(typeof exports === 'object')
		exports["autoloaderCdn"] = factory();
	else
		root["autoloaderCdn"] = factory();
})(window, function() {
return 